import MarkedLectureViewListing from "Pages/MySchedule/TOCModal/MarkedLectureViewListing";
import { useEffect, useState } from "react";
import { Button } from "reactstrap";
import {
  BASE_URL,
  GET_ASSETS_WITH_SM_ID,
} from "utilFunctions/Constants/urlConstants";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

export interface GetAssetsIF {
  nodeId: number | string;
  nodeTitle: string;
  marked: boolean;
  nodeType: string | null;
  enabled: boolean;
}
interface MarkedLectureViewModalIF {
  mode: string;
  isLectureViewModal: boolean;
  setIsLectureViewModal: any;
  selectedlecture: any;
  editHandler?: any;
  inlineView?: boolean;
}

const MarkedLectureViewModal = ({
  mode,
  isLectureViewModal,
  setIsLectureViewModal,
  selectedlecture,
  editHandler,
  inlineView = false,
}: MarkedLectureViewModalIF) => {
  const { screen }: any = useWindowSize();
  const [lectureAssetsData, setlectureAssetsData] = useState<GetAssetsIF[]>([]);
  const { makeRequest: PostGetAssets, loading: Loader } = usePutPostAPI(
    (data: any) => {
      if (data["data"] && data["data"] && data["data"]["nodesList"].length) {
        setlectureAssetsData(data["data"]["nodesList"]);
      } else {
        setlectureAssetsData([]);
      }
    },
    (error) => {
      setlectureAssetsData([]);
      console.log(error);
    },
    "Post"
  );
  useEffect(() => {
    if (
      Object.keys(selectedlecture).length &&
      (selectedlecture.revisionRank == null ||
        parseInt(selectedlecture.revisionRank) == 0)
    ) {
      const url = BASE_URL + GET_ASSETS_WITH_SM_ID;
      const obj = {
        lectureId: selectedlecture?.fexRecordId,
      };
      PostGetAssets(url, obj);
    } else {
      setlectureAssetsData([
        {
          nodeTitle:
            "Revision Lecture " + selectedlecture.revisionRank + " marked",
          nodeId: "revision_" + selectedlecture.revisionRank,
          nodeType: null,
          marked: false,
          enabled: false,
        },
      ]);
    }
  }, [selectedlecture]);

  const Toggle = () => {
    setIsLectureViewModal(!isLectureViewModal);
  };
  return (
    <>
      {["xs", "sm", "md"].includes(screen) ? (
        <div style={{ paddingBottom: "70px", position: "relative" }}>
          <MarkedLectureViewListing
            Loader={Loader}
            data={lectureAssetsData}
          ></MarkedLectureViewListing>
          <div
            className="filterFooter p-0"
            style={{
              position: "fixed",
              bottom: "64px",
              left: 0,
              right: 0,
              zIndex: 999,
            }}
          >
            {["myScheduled"].includes(mode) ? (
              <Button
                color={"aeslPrimary footerAddCommentBtn"}
                className="d-flex justify-content-center w-100"
                onClick={() => {
                  Toggle();
                  editHandler(lectureAssetsData);
                }}
              >
                Edit
              </Button>
            ) : null}
          </div>
        </div>
      ) : inlineView ? (
        <div className="markedLectureInlineWrapper">
          <div className="markedLectureViewModalBody">
            <MarkedLectureViewListing
              Loader={Loader}
              data={lectureAssetsData}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "16px",
                borderTop: "1px solid #E5E5E5",
                position: "fixed",
                bottom: "0px",
                right: "0px",
              }}
            >
              {mode === "myScheduled" && (
                <Button
                  color="aeslPrimary"
                  onClick={(e) => {
                    Toggle();
                    e.stopPropagation();
                    editHandler?.(lectureAssetsData);
                  }}
                >
                  Edit
                </Button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div
            className={
              ["xs", "sm", "md"].includes(screen)
                ? "markedLectureViewModalBodyMB"
                : "markedLectureViewModalBody"
            }
          >
            <MarkedLectureViewListing
              Loader={Loader}
              data={lectureAssetsData}
            />
          </div>

          {mode === "myScheduled" && (
            <Button
              color="aeslPrimary"
              onClick={() => {
                Toggle();
                editHandler?.(lectureAssetsData);
              }}
            >
              Edit
            </Button>
          )}
        </div>
      )}
    </>
  );
};
export default MarkedLectureViewModal;
